module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataReady) ? _c('div', {
    staticClass: "tab-content-declarations noselect"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "id": "app"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.enregistrer($event)
      }
    }
  }, [_c('div', {
    staticClass: "body-tab"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "head mb-1"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "sub mr-2"
  }, [_vm._v("Lien avec l'employeur ?")]), _vm._v(" "), _c('div', {
    staticClass: "inp-yes-no"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.LienAvecEmployeur),
      expression: "salarieCourant.LienAvecEmployeur"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkboxLienEmployeur"
    },
    domProps: {
      "checked": Array.isArray(_vm.salarieCourant.LienAvecEmployeur) ? _vm._i(_vm.salarieCourant.LienAvecEmployeur, null) > -1 : (_vm.salarieCourant.LienAvecEmployeur)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.salarieCourant.LienAvecEmployeur,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.salarieCourant, "LienAvecEmployeur", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.salarieCourant, "LienAvecEmployeur", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.salarieCourant, "LienAvecEmployeur", $$c)
        }
      }, _vm.modify]
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeSituationMaritale),
      expression: "salarieCourant.CodeSituationMaritale"
    }],
    staticClass: "input",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeSituationMaritale", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modify]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeSituationMaritale), function(situationMaritale) {
    return _c('option', {
      domProps: {
        "value": situationMaritale.Code
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(situationMaritale.Libelle) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Situation maritale")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateUnion),
      expression: "dateUnion"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " "
    },
    domProps: {
      "value": (_vm.dateUnion)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateUnion = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.LieuUnion),
      expression: "salarieCourant.LieuUnion"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": " ",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.salarieCourant.LieuUnion)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "LieuUnion", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Lieu")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.NbrEnfants),
      expression: "salarieCourant.NbrEnfants"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": " ",
      "step": "1",
      "min": "0",
      "max": "20"
    },
    domProps: {
      "value": (_vm.salarieCourant.NbrEnfants)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "NbrEnfants", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Enfants")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.NbrPersonnesACharge),
      expression: "salarieCourant.NbrPersonnesACharge"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": " ",
      "step": "1",
      "min": "0",
      "max": "20"
    },
    domProps: {
      "value": (_vm.salarieCourant.NbrPersonnesACharge)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "NbrPersonnesACharge", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Personne à charge")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.DateChangementLogiciel),
      expression: "DateChangementLogiciel"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " ",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.DateChangementLogiciel)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.DateChangementLogiciel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Date changement de contrat")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.NumeroContratAncienLogiciel),
      expression: "salarieCourant.NumeroContratAncienLogiciel"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": " ",
      "disabled": !_vm.canModify,
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.salarieCourant.NumeroContratAncienLogiciel)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "NumeroContratAncienLogiciel", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Numéro de contrat ancien système")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input input-prelevement"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.IdentifiantTauxPrelevALaSource),
      expression: "salarieCourant.IdentifiantTauxPrelevALaSource"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": " ",
      "readonly": !_vm.isModDemarrage,
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.salarieCourant.IdentifiantTauxPrelevALaSource)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "IdentifiantTauxPrelevALaSource", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Identifiant taux prélèvement à la source")]), _vm._v(" "), _vm._m(3)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "head mb-1"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('button', {
    staticClass: "inp-button-circle",
    attrs: {
      "type": "button",
      "title": "Ajouter un conjoint"
    },
    on: {
      "click": function($event) {
        _vm.addPersonne('C')
      }
    }
  }, [_c('span', {
    staticClass: "icon fas fa-plus"
  })])])]), _vm._v(" "), (_vm.salarieCourant.Conjoints.length) ? _c('div', {
    staticClass: "inp-table inp-table-conjoint noselect"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "tbody"
  }, [_vm._m(6), _vm._v(" "), _vm._l((_vm.salarieCourant.Conjoints), function(conjoint) {
    return _c('div', {
      staticClass: "tr"
    }, [_c('div', {
      staticClass: "td cln-nom"
    }, [_vm._v(_vm._s(conjoint.Nom))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-prenom"
    }, [_vm._v(_vm._s(conjoint.Prenom))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-ne text-center"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")(conjoint.DateNaissance, "DD/MM/YYYY")) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-lieu"
    }, [_vm._v(_vm._s(conjoint.LieuNaissance))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-profession"
    }, [_vm._v(_vm._s(conjoint.Profession))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-sexe text-center"
    }, [(conjoint.Sexe == 'M') ? _c('span', {
      staticStyle: {
        "font-size": "1.5em",
        "color": "#8ECDFC"
      }
    }, [_c('span', {
      staticClass: "fas fa-male"
    })]) : _c('span', {
      staticStyle: {
        "font-size": "1.5em",
        "color": "#F78B9C"
      }
    }, [_c('span', {
      staticClass: "fas fa-female"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "td cln-fin text-center"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")(conjoint.DateFin, "DD/MM/YYYY")) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-action"
    }, [_c('button', {
      staticClass: "inp-button orange",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editPersonne(conjoint, 'C')
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-user-edit"
    })]), _vm._v(" "), _c('button', {
      staticClass: "inp-button red",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deletePersonne(conjoint, 'C')
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-user-times"
    })])])])
  })], 2)]) : _c('div', {
    staticClass: "card p-3"
  }, [_vm._m(7)])])]), _vm._v(" "), _c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "head mb-1"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('button', {
    staticClass: "inp-button-circle",
    attrs: {
      "type": "button",
      "title": "Ajouter un enfant"
    },
    on: {
      "click": function($event) {
        _vm.addPersonne('E')
      }
    }
  }, [_c('span', {
    staticClass: "icon fas fa-plus"
  })])])]), _vm._v(" "), (_vm.salarieCourant.Enfants.length) ? _c('div', {
    staticClass: "inp-table inp-table-enfant noselect"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "tbody"
  }, [_vm._m(10), _vm._v(" "), _vm._l((_vm.salarieCourant.Enfants), function(enfant) {
    return _c('div', {
      staticClass: "tr"
    }, [_c('div', {
      staticClass: "td cln-nom"
    }, [_vm._v(_vm._s(enfant.Nom))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-prenom"
    }, [_vm._v(_vm._s(enfant.Prenom))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-ne text-center"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")(enfant.DateNaissance, "DD/MM/YYYY")) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-lieu"
    }, [_vm._v(_vm._s(enfant.LieuNaissance))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-sexe text-center"
    }, [(enfant.Sexe == 'M') ? _c('span', {
      staticStyle: {
        "font-size": "1.5em",
        "color": "#8ECDFC"
      }
    }, [_c('span', {
      staticClass: "fas fa-male"
    })]) : _c('span', {
      staticStyle: {
        "font-size": "1.5em",
        "color": "#F78B9C"
      }
    }, [_c('span', {
      staticClass: "fas fa-female"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "td cln-observation"
    }, [_vm._v(_vm._s(enfant.Profession))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-action"
    }, [_c('button', {
      staticClass: "inp-button orange",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editPersonne(enfant, 'E')
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-user-edit"
    })]), _vm._v(" "), _c('button', {
      staticClass: "inp-button red",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deletePersonne(enfant, 'E')
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-user-times"
    })])])])
  })], 2)]) : _c('div', {
    staticClass: "card p-3"
  }, [_vm._m(11)])])]), _vm._v(" "), _c('div', {
    staticClass: "row area"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "head mb-1"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('button', {
    staticClass: "inp-button-circle",
    attrs: {
      "type": "button",
      "title": "Ajouter une personne à charge"
    },
    on: {
      "click": function($event) {
        _vm.addPersonne('A')
      }
    }
  }, [_c('span', {
    staticClass: "icon fas fa-plus"
  })])])]), _vm._v(" "), (_vm.salarieCourant.AutresPersonnesACharge.length) ? _c('div', {
    staticClass: "inp-table inp-table-enfant noselect"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "tbody"
  }, [_vm._m(14), _vm._v(" "), _vm._l((_vm.salarieCourant.AutresPersonnesACharge), function(personne) {
    return _c('div', {
      staticClass: "tr"
    }, [_c('div', {
      staticClass: "td cln-nom"
    }, [_vm._v(_vm._s(personne.Nom))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-prenom"
    }, [_vm._v(_vm._s(personne.Prenom))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-ne text-center"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")(personne.DateNaissance, "DD/MM/YYYY")) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-lieu"
    }, [_vm._v(_vm._s(personne.LieuNaissance))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-sexe text-center"
    }, [(personne.Sexe == 'M') ? _c('span', {
      staticStyle: {
        "font-size": "1.5em",
        "color": "#8ECDFC"
      }
    }, [_c('span', {
      staticClass: "fas fa-male"
    })]) : _c('span', {
      staticStyle: {
        "font-size": "1.5em",
        "color": "#F78B9C"
      }
    }, [_c('span', {
      staticClass: "fas fa-female"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "td cln-observation"
    }, [_vm._v(_vm._s(personne.Profession))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-action"
    }, [_c('button', {
      staticClass: "inp-button orange",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editPersonne(personne, 'A')
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-user-edit"
    })]), _vm._v(" "), _c('button', {
      staticClass: "inp-button red",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deletePersonne(personne, 'A')
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-user-times"
    })])])])
  })], 2)]) : _c('div', {
    staticClass: "card p-3"
  }, [_vm._m(15)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.NumeroPermis),
      expression: "salarieCourant.NumeroPermis"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": " ",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.salarieCourant.NumeroPermis)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "NumeroPermis", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("N° permis")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datePermis),
      expression: "datePermis"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " "
    },
    domProps: {
      "value": (_vm.datePermis)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datePermis = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Délivré le")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.PermisDelivrePar),
      expression: "salarieCourant.PermisDelivrePar"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": " ",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.salarieCourant.PermisDelivrePar)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "PermisDelivrePar", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Délivré par")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.LieuDelivrancePermis),
      expression: "salarieCourant.LieuDelivrancePermis"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": " ",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.salarieCourant.LieuDelivrancePermis)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "LieuDelivrancePermis", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Lieu")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.NumeroCarteSejour),
      expression: "salarieCourant.NumeroCarteSejour"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": " ",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.salarieCourant.NumeroCarteSejour)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "NumeroCarteSejour", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("N° Carte de séjour")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateCarteSejour),
      expression: "dateCarteSejour"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " "
    },
    domProps: {
      "value": (_vm.dateCarteSejour)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateCarteSejour = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Délivré le")])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateFinCarteSejour),
      expression: "dateFinCarteSejour"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " "
    },
    domProps: {
      "value": (_vm.dateFinCarteSejour)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateFinCarteSejour = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Fin de validité")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CarteSejourDelivrePar),
      expression: "salarieCourant.CarteSejourDelivrePar"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": " ",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.salarieCourant.CarteSejourDelivrePar)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "CarteSejourDelivrePar", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Délivré par")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.LieuDelivranceCarteSejour),
      expression: "salarieCourant.LieuDelivranceCarteSejour"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": " ",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.salarieCourant.LieuDelivranceCarteSejour)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "LieuDelivranceCarteSejour", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Lieu")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "inp-input icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeCollege),
      expression: "salarieCourant.CodeCollege"
    }],
    staticClass: "input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeCollege", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modify]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeCollege), function(college) {
    return _c('option', {
      domProps: {
        "value": college.Code
      }
    }, [_vm._v(_vm._s(college.Libelle) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Collège")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "inp-input icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeSection),
      expression: "salarieCourant.CodeSection"
    }],
    staticClass: "input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeSection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modify]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeSection), function(section) {
    return _c('option', {
      domProps: {
        "value": section.Code
      }
    }, [_vm._v(_vm._s(section.Libelle) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Section")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "inp-input icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeLieuVote),
      expression: "salarieCourant.CodeLieuVote"
    }],
    staticClass: "input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeLieuVote", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modify]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeLieuVote), function(lieuVote) {
    return _c('option', {
      domProps: {
        "value": lieuVote.Code
      }
    }, [_vm._v(_vm._s(lieuVote.Libelle) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Lieu de vote")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-7"
  }, [_c('div', {
    staticClass: "inp-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.LogementPourcentPatronal),
      expression: "salarieCourant.LogementPourcentPatronal"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkboxLogementPourcentPatronal",
      "disabled": !_vm.canModify
    },
    domProps: {
      "checked": Array.isArray(_vm.salarieCourant.LogementPourcentPatronal) ? _vm._i(_vm.salarieCourant.LogementPourcentPatronal, null) > -1 : (_vm.salarieCourant.LogementPourcentPatronal)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.salarieCourant.LogementPourcentPatronal,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.salarieCourant, "LogementPourcentPatronal", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.salarieCourant, "LogementPourcentPatronal", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.salarieCourant, "LogementPourcentPatronal", $$c)
        }
      }, _vm.modify]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pl-2",
    attrs: {
      "for": "checkboxLogementPourcentPatronal"
    }
  }, [_vm._v("Logement\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t1% Patronal")])])]), _vm._v(" "), (_vm.salarieCourant.LogementPourcentPatronal) ? _c('div', {
    staticClass: "col-5"
  }, [_c('div', {
    staticClass: "inp-input-mini"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateLogementPourcentPatronal),
      expression: "dateLogementPourcentPatronal"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " ",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.dateLogementPourcentPatronal)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateLogementPourcentPatronal = $event.target.value
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-7"
  }, [_c('div', {
    staticClass: "inp-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.TravailleurHandicape),
      expression: "salarieCourant.TravailleurHandicape"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkboxTravailleurHandicape",
      "disabled": !_vm.canModify
    },
    domProps: {
      "checked": Array.isArray(_vm.salarieCourant.TravailleurHandicape) ? _vm._i(_vm.salarieCourant.TravailleurHandicape, null) > -1 : (_vm.salarieCourant.TravailleurHandicape)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.salarieCourant.TravailleurHandicape,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.salarieCourant, "TravailleurHandicape", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.salarieCourant, "TravailleurHandicape", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.salarieCourant, "TravailleurHandicape", $$c)
        }
      }, _vm.modify]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pl-2",
    attrs: {
      "for": "checkboxTravailleurHandicape"
    }
  }, [_vm._v("Travailleur handicapé (%)")])])]), _vm._v(" "), (_vm.salarieCourant.TravailleurHandicape) ? _c('div', {
    staticClass: "col-5"
  }, [_c('div', {
    staticClass: "inp-input-mini"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.PourcentageHandicape),
      expression: "salarieCourant.PourcentageHandicape"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": " ",
      "max": "100",
      "min": "0",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.salarieCourant.PourcentageHandicape)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "PourcentageHandicape", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), (_vm.salarieCourant.ContratActif) ? _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-7"
  }, [_c('div', {
    staticClass: "inp-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.OutilsIssusNtic),
      expression: "salarieCourant.OutilsIssusNtic"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkboxOutilsNTIC",
      "disabled": !_vm.canModify
    },
    domProps: {
      "checked": Array.isArray(_vm.salarieCourant.OutilsIssusNtic) ? _vm._i(_vm.salarieCourant.OutilsIssusNtic, null) > -1 : (_vm.salarieCourant.OutilsIssusNtic)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.salarieCourant.OutilsIssusNtic,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.salarieCourant, "OutilsIssusNtic", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.salarieCourant, "OutilsIssusNtic", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.salarieCourant, "OutilsIssusNtic", $$c)
        }
      }, _vm.modify]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pl-2",
    attrs: {
      "for": "checkboxOutilsNTIC"
    }
  }, [_vm._v("Outils issus des\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tNTIC")])])]), _vm._v(" "), (_vm.salarieCourant.OutilsIssusNtic) ? _c('div', {
    staticClass: "col-5"
  }, [_c('div', {
    staticClass: "inp-input-mini"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.ValeurNtic),
      expression: "salarieCourant.ValeurNtic"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": " ",
      "max": "999999999.99",
      "min": "0",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.salarieCourant.ValeurNtic)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "ValeurNtic", $event.target.value)
      }
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.salarieCourant.ContratActif) ? _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "inp-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CumulEmploiRetraite),
      expression: "salarieCourant.CumulEmploiRetraite"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkboxCumulEmploiRetraite",
      "disabled": !_vm.canModify
    },
    domProps: {
      "checked": Array.isArray(_vm.salarieCourant.CumulEmploiRetraite) ? _vm._i(_vm.salarieCourant.CumulEmploiRetraite, null) > -1 : (_vm.salarieCourant.CumulEmploiRetraite)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.salarieCourant.CumulEmploiRetraite,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.salarieCourant, "CumulEmploiRetraite", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.salarieCourant, "CumulEmploiRetraite", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.salarieCourant, "CumulEmploiRetraite", $$c)
        }
      }, _vm.modify]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pl-2",
    attrs: {
      "for": "checkboxCumulEmploiRetraite"
    }
  }, [_vm._v("Cumul\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\temploi retraite")])])])]) : _vm._e(), _vm._v(" "), (_vm.salarieCourant.ContratActif) ? _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "inp-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.Teletravail),
      expression: "salarieCourant.Teletravail"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkboxContratTeletravail",
      "disabled": !_vm.canModify
    },
    domProps: {
      "checked": Array.isArray(_vm.salarieCourant.Teletravail) ? _vm._i(_vm.salarieCourant.Teletravail, null) > -1 : (_vm.salarieCourant.Teletravail)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.salarieCourant.Teletravail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.salarieCourant, "Teletravail", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.salarieCourant, "Teletravail", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.salarieCourant, "Teletravail", $$c)
        }
      }, _vm.modify]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pl-2",
    attrs: {
      "for": "checkboxContratTeletravail"
    }
  }, [_vm._v("Contrat en\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ttélétravail")])])])]) : _vm._e()])])])])])])])]), _vm._v(" "), (_vm.isModified) ? _c('div', {
    staticClass: "validation-area mt-3"
  }, [_c('div', {
    staticClass: "area-action"
  }, [_vm._m(20), _vm._v(" "), _c('button', {
    staticClass: "inp-button-modal cancel ml-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.annuler()
      }
    }
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Annuler")])])])]) : _vm._e(), _vm._v(" "), _c('modal-ajout-edit-personnes', {
    ref: "modalAjoutEditPersonnes",
    on: {
      "ajout": _vm.ajoutPersonne,
      "update": _vm.modificationPersonne
    }
  })], 1)]) : _c('loader', {
    staticClass: "loader"
  })
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Situation maritale")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "checkboxLienEmployeur"
    }
  }, [_c('span', {
    staticClass: "ui"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("DSN")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infobulle"
  }, [_c('span', [_vm._v("Cet identifiant du taux est automatiquement mis à jour à la prochaine récupération de la DSN ou lors de la récupération du Topaze")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Conjoints")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thead"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th cln-nom",
    attrs: {
      "title": "Nom"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Nom")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-prenom",
    attrs: {
      "title": "Prénom"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Prénom")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-ne",
    attrs: {
      "title": "Né le"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Né le")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-lieu",
    attrs: {
      "title": "Lieu de naissance"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Lieu de naissance")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-profession",
    attrs: {
      "title": "Profession"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Profession")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-sexe",
    attrs: {
      "title": "Sexe"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Sexe")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-fin",
    attrs: {
      "title": "Date de fin"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Date de fin")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-action",
    attrs: {
      "title": "Action"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Action")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "section cln-nom"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-prenom"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-ne"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-lieu"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-profession"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-sexe"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-fin"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-action"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_vm._v("Aucun conjoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Enfants")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thead"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th cln-nom",
    attrs: {
      "title": "Nom"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Nom")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-prenom",
    attrs: {
      "title": "Prénom"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Prénom")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-ne",
    attrs: {
      "title": "Né le"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Né le")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-lieu",
    attrs: {
      "title": "Lieu de naissance"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Lieu de naissance")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-sexe",
    attrs: {
      "title": "Sexe"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Sexe")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-observation",
    attrs: {
      "title": "Observation"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Observation")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-action",
    attrs: {
      "title": "Action"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Action")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "section cln-nom"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-prenom"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-ne"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-lieu"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-sexe"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-observation"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-action"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_vm._v("Aucun enfant")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Autres personnes à charge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thead"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th cln-nom",
    attrs: {
      "title": "Nom"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Nom")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-prenom",
    attrs: {
      "title": "Prénom"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Prénom")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-ne",
    attrs: {
      "title": "Né le"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Né le")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-lieu",
    attrs: {
      "title": "Lieu de naissance"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Lieu de naissance")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-sexe",
    attrs: {
      "title": "Sexe"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Sexe")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-observation",
    attrs: {
      "title": "Observation"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Observation")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-action",
    attrs: {
      "title": "Action"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Action")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "section cln-nom"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-prenom"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-ne"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-lieu"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-sexe"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-observation"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-action"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_vm._v("Aucune personne à charge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Permis de conduire")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Carte de séjour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Élections Prud'homales")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Particularités")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "inp-button-modal valid",
    attrs: {
      "type": "submit"
    }
  }, [_c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-check"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Valider")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51aa5d2c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ficheSalarie/declarations/declarationsSalarie.vue.html
// module id = tKFH
// module chunks = 2